import NotificationPlaceholder from './NotificationPlaceholder.component';

export default NotificationPlaceholder;
